interface Props {
    activeColor?: string;
}

export const InfoShield = ({ activeColor = "#2563EB" }: Props) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Shield */}
            <path
                d="M12 3L19 6V11C19 16 15.5 20.5 12 22C8.5 20.5 5 16 5 11V6L12 3Z"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            {/* Info dot */}
            <circle
                cx="12"
                cy="9"
                r="1"
                fill={activeColor}
            />

            {/* Info line */}
            <path
                d="M12 12V16"
                stroke={activeColor}
                strokeWidth="1.8"
                strokeLinecap="round"
            />
        </svg>
    );
};